export default "__VITE_ASSET__BvQJmfCr__"